import { Loader } from '../Loader';
import { StyledWrapper } from './FullPageLoader.styles';

export const FullPageLoader = () => (
  <StyledWrapper>
    <Loader variant="blue" size="big" />
  </StyledWrapper>
);
